module.exports = __webpack_public_path__ + "static/media/8.Hammer 2-20, 2-26.02dd8b28.jpg";